/**
 * external libs
 */
import {Outlet, Route, Routes} from "react-router";
import React, {Suspense, useMemo} from "react";
/**
 * components
 */
import Layout from "../Layout";

/**
 * routes
 */
import {webRoutes} from "./routes/web.routes";

export default function RoutesComponent() {
    const routes = useMemo(() => webRoutes(), [])

    return (
        <Routes>
            <Route
                element={
                    <Layout>
                        <Outlet />
                    </Layout>
                }
            >
                {routes.withLayout.map((route, i) => (
                    <route.layout
                        exact={route.exact}
                        key={`with-layout-${i}`}
                        path={route.path}
                        element={route.element}
                    />
                ))}
            </Route>
        </Routes>
    )
}

